<template>
  <IconBoxZzim :section="section" :is-on="isOn" :toggle-fn="toggle" :title="title" :zzim-icon="zzimIcon" />
</template>

<script>
import IconBoxZzim from '@/components/play/IconBoxZzim'
import { MyPooqService } from '@/common/api/api.service'
import utils from '@/common/util/utils'
import {
  MSG_COMPLETE_ADD_ZZIM_LIVE, MSG_COMPLETE_ADD_ZZIM_MOVIE,
  MSG_COMPLETE_ADD_ZZIM_PROGRAM, MSG_COMPLETE_DELETE_ZZIM_LIVE, MSG_COMPLETE_DELETE_ZZIM_MOVIE,
  MSG_COMPLETE_DELETE_ZZIM_PROGRAM
} from '@/common/constant'
export default {
  name: 'IconBoxZzimWithApi',
  components: { IconBoxZzim },
  props: {
    contentId: {
      type: String
    },
    section: {
      type: String
    },
    zzim: {
      type: String
    }
  },
  data () {
    return {
      isOn: false,
      device: utils.cookies.getDevice()
    }
  },
  computed: {
    title () {
      return '관심'
    },
    zzimIcon () {
      return this.isOn ? 'un-like-button' : 'like-button'
    }
  },
  methods: {
    // todo: 로직 체크 필요 11/2
    getContentTypeBySection () {
      let contentType = null
      if (this.section === 'vod') {
        contentType = 'program'
      }
      if (this.section === 'live') {
        contentType = 'live'
      }
      if (this.section === 'movie') {
        contentType = 'movie'
      }
      return contentType
    },
    getSubscribeMessageBySection () {
      let subscripMesssage = ''
      if (this.section === 'vod') {
        subscripMesssage = MSG_COMPLETE_ADD_ZZIM_PROGRAM
      }
      if (this.section === 'live') {
        subscripMesssage = MSG_COMPLETE_ADD_ZZIM_LIVE
      }
      if (this.section === 'movie') {
        subscripMesssage = MSG_COMPLETE_ADD_ZZIM_MOVIE
      }
      return subscripMesssage
    },
    getUnSubscribeMessageBySection () {
      let unSubscripMessage = ''
      if (this.section === 'vod') {
        unSubscripMessage = MSG_COMPLETE_DELETE_ZZIM_PROGRAM
      }
      if (this.section === 'live') {
        unSubscripMessage = MSG_COMPLETE_DELETE_ZZIM_LIVE
      }
      if (this.section === 'movie') {
        unSubscripMessage = MSG_COMPLETE_DELETE_ZZIM_MOVIE
      }
      return unSubscripMessage
    },
    ifDintLoginThenGoLogin () {
      return this.device === 'mobile' && utils.cookies.getCredential() === 'none'
    },
    toggle () {
      if (this.ifDintLoginThenGoLogin()) {
        this.$router.replace(`/login?referer=${this.$route.fullPath.replace(location.origin, '')}`)
        return
      }
      const contentType = this.getContentTypeBySection()
      if (this.isOn) {
        MyPooqService.deleteZzim({
          contenttype: contentType,
          contentids: [this.contentId],
          delalarm: 'y'
        }).then(({ data }) => {
          if (data.resultcode === '200') {
            this.$toast({ message: this.getUnSubscribeMessageBySection() })
            this.$nextTick(() => {
              this.isOn = false
            })
          } else {
            this.$toast({ message: data.resultmessage })
          }
        })
      } else {
        if (this.section === 'vod' && this.contentId === '') {
          utils.alert('해당 콘텐츠는 관심 기능을 지원하지 않습니다.')
          return
        }
        MyPooqService.setZzim({
          contentid: this.contentId,
          contenttype: contentType,
          addalarm: 'y'
        }).then(({ data }) => {
          if (data.resultcode === '200') {
            this.$toast({ message: this.getSubscribeMessageBySection() })
            this.$nextTick(() => {
              this.isOn = true
            })
          } else {
            this.$toast({ message: data.resultmessage })
          }
        })
      }
    }
  },
  created () {
    this.isOn = this.zzim === 'y'
  }
}
</script>
